// extracted by mini-css-extract-plugin
module.exports = {"float-btn-wrap":"gv","floatBtnWrap":"gv","float-btn-snapping":"gw","floatBtnSnapping":"gw","float-btn-close":"gx","floatBtnClose":"gx"};